export default [
    {
      path: '/admin/settings',
      name: 'setting',
      meta: { requiresAuth: true },
      component: () => import('@/pages/setting/index.vue')
    }
  ]
  